module.exports = __webpack_public_path__ + "img/ins.50656a74.svg";